export default __webpack_public_path__ + "static/media/Clan Bound Belt of the Ancestors.38871ffb.jpg";